import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { fontSize, getLoginUrl } from "@/components/signup/utils";
import { Link } from "@/libraries/design/components";
import { useLocation } from "@/utils/location-provider";

export const Login = ({ loginText }: { loginText?: ReactNode }) => {
    const intl = useIntl();
    const location = useLocation();

    if (loginText === undefined) {
        loginText = intl.formatMessage(
            {
                id: "gwp.signinForm.loginText",
                defaultMessage: "<logInLink>Log in</logInLink>"
            },
            {
                logInLink: (text: ReactNode) => logInLink(text, location)
            }
        );
    }

    return <p css={existingProductCss}>{loginText}</p>;
};

const logInLink = (text: ReactNode, location: Location) => (
    <Link
        text={text as unknown as string}
        aria-label={text as unknown as string}
        type="inline"
        href={getLoginUrl(location)}
    />
);

const existingProductCss = css({
    fontSize: fontSize.sm,
    margin: "2rem 0 0 !important",
    textAlign: "center"
});
